/** The referrer a visitor arrived with through /r/<id>: first touch wins, kept 30 days, sent once at the first CADINU sign-in. */
const KEY = 'cadinu.ref'
const TTL = 30 * 24 * 3600 * 1000

export function storeRef(wallet: string) {
  try {
    const cur = JSON.parse(window.localStorage.getItem(KEY) || 'null')
    if (cur && Date.now() - cur.at < TTL) return
    window.localStorage.setItem(KEY, JSON.stringify({ wallet, at: Date.now() }))
  } catch {
    /* ignore */
  }
}
export function readRef(): string | undefined {
  try {
    const cur = JSON.parse(window.localStorage.getItem(KEY) || 'null')
    return cur && Date.now() - cur.at < TTL ? cur.wallet : undefined
  } catch {
    return undefined
  }
}
